import { z } from 'zod';
import { latLngSchema, uuidSchema } from './common.js';
/** A stock-holding depot. Several can exist; one is the default in settings. */
export const createWarehouseSchema = z.object({
    code: z.string().trim().min(1).max(24),
    name: z.string().trim().min(1).max(120),
    address: z.string().trim().max(300).nullish(),
    /** Needed before the warehouse can be a route start or end point. */
    location: latLngSchema.nullish(),
    isActive: z.boolean().default(true),
});
export const updateWarehouseSchema = createWarehouseSchema.partial();
export const warehouseSchema = z.object({
    id: uuidSchema,
    code: z.string(),
    name: z.string(),
    address: z.string().nullable(),
    location: latLngSchema.nullable(),
    isActive: z.boolean(),
});
/**
 * A delivery vehicle. Stock belongs to the vehicle rather than to its driver,
 * so the admin can reassign a van without moving its load.
 */
export const createVehicleSchema = z.object({
    /** Italian plate, e.g. AB123CD. Stored uppercase. */
    plate: z
        .string()
        .trim()
        .min(4)
        .max(16)
        .regex(/^[A-Za-z0-9 -]+$/, { message: 'validation.plate' })
        .transform((v) => v.toUpperCase().replace(/\s+/g, '')),
    label: z.string().trim().max(80).nullish(),
    notes: z.string().trim().max(1000).nullish(),
    isActive: z.boolean().default(true),
});
export const updateVehicleSchema = createVehicleSchema.partial();
export const vehicleSchema = z.object({
    id: uuidSchema,
    plate: z.string(),
    label: z.string().nullable(),
    notes: z.string().nullable(),
    isActive: z.boolean(),
    /** Staff currently assigned to this vehicle, if any. */
    assignedUserIds: z.array(uuidSchema),
});
//# sourceMappingURL=facility.js.map